import { StaticImage } from '@/common/constants/displateRoutes';
import {
  FooterInfoBoxHeader,
  FooterInfoBoxSingleIcon,
  FooterInfoBoxText,
  FooterInfoBoxWrapper,
} from '@/modules/ProductPage/components/Footer/FooterInfoBox.styled';

const FooterDeliveryBox = () => {
  return (
    <FooterInfoBoxWrapper>
      <FooterInfoBoxHeader>100 days for return</FooterInfoBoxHeader>
      <FooterInfoBoxText>Easy return, no questions asked</FooterInfoBoxText>
      <FooterInfoBoxSingleIcon
        alt="clock icon"
        src={StaticImage('/images/footer/return_clock.svg')}
      />
    </FooterInfoBoxWrapper>
  );
};

export default FooterDeliveryBox;
